var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
var LearningProjectComponent = (function () {
    function LearningProjectComponent(route, router, apiService, commonService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.commonService = commonService;
        this.isPC = false;
        this.assetsRoute = '../../assets';
        this.isShowPrompt = false; //是否显示toast
        this.circleTheme = {
            'width': 300,
            'height': 300,
            'x': 0,
            'y': 0,
            'radius': 90,
            'innerRadius': 20,
            'startAngle': 0,
            'endAngle': 360,
            'angleRadian': 275,
            'colors': ['#7E9FFB', '#5F81DB', '#60B68A', '#44976C', '#EEE'] //环形颜色
        }; //主题
        this.progressBarTheme = {
            'name': 'project',
            'haveTitle': true,
            'color': 'rgb(105,136,238)',
            'radius': '0.2rem'
        }; //主题
        this.isShowBar = true; //是否显示进度条
        this.postData = []; //传递数据
        this.isShowvideoDialog = false; // 是否显示播放器
        this.isShowVideoBtn = false; // 是否显示启动视频按钮
        this.isClickPlay = false; // 是否点击过播放按钮
        this.homeWorkLock = false;
        this.buttonTheme = {
            'position': 'bottom',
            'fontSize': 'fontSize15',
            'buttonElem': [
                {
                    'color': 'blue',
                    'text': '进入学习',
                    'className': 'inlineBlockRadiusBtn'
                }
            ]
        }; //按钮主题
        this.videoId = ''; // 宣讲视频id
        this.courseDuration = {
            0: '35min',
            1: '1h 30min',
            205: '1h 30min',
            305: '1h 50min',
            315: '1h 50min',
            325: '1h 50min',
            335: '1h 50min',
            405: '1h 30min',
            605: '2h 30min',
            2: '1h 25min',
            11: '1h 10min',
            403: '1h 10min',
            12: '60min',
            13: '1h 20min',
            14: '1h 20min',
            15: '1h 20min',
            607: '2h 20min',
            307: '1h 35min',
            317: '1h 55min',
            327: '1h 35min',
            16: '1h 15min',
            18: '25min',
            404: '1h 25min',
            20: '1h 20min',
            24: '2h 20min',
            406: '2h 20min',
            606: '3h 20min',
            26: '1h 20min',
            28: '1h 20min',
            30: '2h 20min',
            201: '2h',
            301: '2h 20min',
            202: '1h 40min',
            302: '2h',
            312: '2h',
            402: '1h 40min',
            208: '1h 30min',
            209: '2h 10min',
            210: '2h 10min',
            308: '1h 35min',
            211: '1h 40min',
            212: '1h 50min',
            304: '1h 40min',
            311: '2h 20min',
            309: '1h 35min',
            318: '1h 35min',
            303: '1h 30min',
            204: '1h 55min',
            6001: '38min'
        };
        this.tabList = [];
        this.tabType = 0;
        this.tabIndex = 0;
        this.isFirstAITraining = true;
        this.isHaveAITraining = false;
        this.guideTipCon = '沉浸式真人陪练，再也不用“话到嘴边说不出口”。';
        this.guideTipBtn = '下一步';
        this.stepNum = 0; //新手引导点击的次数
        this.firstAITrainingData = {}; //智能陪练列表里的第一个card数据
        this.allTotalNum = 0; //智能陪练中tab全部的数量
        this.isStickey = false; //是否吸顶
        this.ArrPos = []; //记录滚动的距离
        this.tour_id = 0;
        this.guideStyle = false;
        this.totalProgress = 0;
    }
    LearningProjectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.ArrPos = JSON.parse(localStorage.getItem('scrollHeight')) ? JSON.parse(localStorage.getItem('scrollHeight')) : [];
        // 清除训练营相关信息
        localStorage.removeItem('skuId');
        localStorage.removeItem('campId');
        localStorage.removeItem('moduleId');
        localStorage.removeItem('learningPathMetaId');
        localStorage.setItem('learningPathMetaId', '');
        //进入学地图时,各能力学习时长不计时
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.isPC = localStorage.getItem('isPC') ? true : false;
        this.route.params.subscribe(function (params) {
            _this.projectId = params['projectId'];
            localStorage.setItem('projectId', _this.projectId);
        });
        var self = this;
        // 获取项目下课程列表信息
        this.getProjectProgress(this.projectId).then(function (res) {
            localStorage.removeItem('projectmsg');
            if (res[0].totalCourseNum && res[0].totalCourseNum > 0) {
                res[0].learningPathMetasDetailList.forEach(function (item) {
                    if (item.projectLearingToursVo) {
                        var preTestOpenAt = item.projectLearingToursVo.preTestOpenAt;
                        item.projectLearingToursVo.openTime = preTestOpenAt ? _this.tansFromTimestamp(preTestOpenAt, 1) : '';
                        item.projectLearingToursVo.promptTime = preTestOpenAt ? _this.tansFromTimestamp(preTestOpenAt, 2) : '';
                    }
                });
            }
            if (res[0].totalCampMetasNum && res[0].totalCampMetasNum > 0) {
                res[0].campMetasList.forEach(function (item) {
                    item.campOpenTime = item.preTestOpenTime ? self.tansFromTimestamp(item.preTestOpenTime, 1) : '';
                });
            }
            var learningPathMetasDetailList = [];
            learningPathMetasDetailList = res[0].learningPathMetasDetailList.filter(function (item) { return item.learningPathMetaId != 999; });
            res[0].learningPathMetasDetailList = learningPathMetasDetailList;
            if (res[0].campMetasList.length > 0) {
                res[0].learningPathMetasDetailList = res[0].learningPathMetasDetailList.filter(function (item) { return item.learningPathMetaId !== 0; });
            }
            self.projectMsg = res;
            self.totalProgress = self.projectMsg[0].totalProgress;
            //项目里是否含有智能陪练
            _this.isHaveAITraining = self.projectMsg[0].learningPathMetasDetailList.filter(function (item) { return item.abilityVersion == '智能陪练'; }).length > 0;
            _this.getProjectData();
        }).then(function () {
            if (self.projectMsg[0].videoId) {
                self.isShowVideoBtn = true;
                self.videoId = self.projectMsg[0].videoId;
                if (self.projectMsg[0].isPopUp) {
                    self.openVideo();
                }
            }
            else {
                self.isShowVideoBtn = false;
            }
            _this.CoursesOrProjectCourses(_this.projectId).then(function (res) {
                var contTxt = self.projectMsg[0].learningPathMetasDetailList;
                contTxt.forEach(function (item, index) {
                    res.learning_path_metas.forEach(function (itm) {
                        if (item.learningPathMetaId == itm.id) {
                            contTxt[index] = __assign({}, item, itm);
                        }
                    });
                });
                self.tour_id = res.tour_id;
                self.projectMsg[0].tour_id = res.tour_id;
                self.commonService.setStorage('tourId', self.projectMsg[0].tour_id);
            });
            console.log(self.projectMsg);
            self.campList = [
                {
                    id: 1,
                    projectName: '训练营1',
                    description: '124567',
                    campMetasId: 2,
                }
            ];
        });
    };
    // 时间转化
    LearningProjectComponent.prototype.tansFromTimestamp = function (timestamp, type) {
        var date = new Date(timestamp);
        var Y = date.getFullYear();
        var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        if (type == 1) {
            return M + "." + D;
        }
        else if (type == 2) {
            return Y + "-" + M + "-" + D + " " + h + ":" + m;
        }
        else if (type === 3) {
            return M + "/" + D;
        }
    };
    LearningProjectComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': '#F2F3FA'
        });
    };
    LearningProjectComponent.prototype.setPinpointPicture = function (id) {
        var courseName = this.commonService.getPinpointCourseEnNameById(id);
        if (!courseName) {
            console.warn("No course name found for id: " + id);
            return ''; // 或者返回一个默认图片 URL
        }
        return 'https://ddileaf-uat-oss.oss-cn-shanghai.aliyuncs.com/scorm/pinpoint/' + encodeURIComponent(courseName.trim());
    };
    LearningProjectComponent.prototype.setGuideStyle = function () {
        var _this = this;
        if (!this.isFirstAITraining) {
            setTimeout(function () {
                var dom = document.getElementById('learning-Item');
                if (dom && document.getElementById('guideCon') && document.getElementById('guideTip')) {
                    document.getElementById('guideCon').style.width = dom.offsetWidth + 'px';
                    document.getElementById('guideCon').style.height = dom.offsetHeight + 'px';
                    document.getElementById('guideCon').style.top = dom.offsetTop + 'px';
                    document.getElementById('guideCon').style.left = dom.offsetLeft + 'px';
                    document.getElementById('guideTip').style.top = dom.offsetTop + dom.offsetHeight + 24.5 + 'px';
                    _this.guideStyle = true;
                    _this.changePos(_this.tabIndex);
                }
            }, 200);
        }
    };
    // 储存用户滚动位置
    LearningProjectComponent.prototype.listenScrollTop = function (scrollTop) {
        var _this = this;
        var debounce = function () {
            var timer = null;
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                if (!_this.ArrPos.find(function (item) { return item.index == _this.tabIndex; })) {
                    _this.ArrPos.push({
                        index: _this.tabIndex,
                        scrollTop: scrollTop
                    });
                    sessionStorage.setItem('scrollHeight', JSON.stringify(_this.ArrPos));
                }
                else {
                    _this.ArrPos.find(function (item) { return item.index == _this.tabIndex; }).scrollTop = scrollTop;
                    sessionStorage.setItem('scrollHeight', JSON.stringify(_this.ArrPos));
                }
            }, 200);
        };
        debounce();
    };
    //判断是否之前已经存储过浏览位置 有则直接定位到浏览位置 否则画到顶部
    LearningProjectComponent.prototype.judgePos = function () {
        var _this = this;
        var scrollHeight = JSON.parse(sessionStorage.getItem('scrollHeight'));
        if (scrollHeight.find(function (item) { return item.index == _this.tabIndex; })) {
            var scrollTop = scrollHeight.find(function (item) { return item.index == _this.tabIndex; }).scrollTop;
            this.scrollToView(scrollTop);
        }
        else {
            document.getElementById('learningWrap-out').scrollTo({
                top: 240,
                behavior: 'smooth'
            });
        }
    };
    // 滚动到 上次访问位置
    LearningProjectComponent.prototype.scrollToView = function (scrollTop) {
        setTimeout(function () {
            document.getElementById('learningWrap-out').scrollTo({
                top: scrollTop,
                behavior: 'smooth'
            });
        }, 700);
    };
    LearningProjectComponent.prototype.elementScroll = function (event) {
        var scrollTop = event.target.scrollTop;
        if (scrollTop > 235) {
            this.isStickey = true;
        }
        else {
            this.isStickey = false;
        }
        if (this.isStickey) {
            this.listenScrollTop(scrollTop);
        }
        this.changePos(this.tabIndex);
    };
    // 获取项目列表
    LearningProjectComponent.prototype.getProjectData = function () {
        var _this = this;
        //获取当前项目下课程分类
        this.apiService.getProjectSort(Number(this.projectId)).subscribe(function (res) {
            _this.tabList = res.filter(function (item) { return item.totalNum > 0; });
            _this.allTotalNum = _this.tabList.find(function (item) { return item.type === 0; }).totalNum;
            _this.commonService.getOnceIno(_this.commonService.getOnceValue(_this.projectId, 15)).then(function (result) {
                _this.isFirstAITraining = result;
                _this.setGuideStyle();
                //从当前课程退出来定位在之前的tab
                _this.tabIndex = sessionStorage.getItem('tabIndex') ? Number(sessionStorage.getItem('tabIndex')) : 0;
                _this.tabType = sessionStorage.getItem('tabType') ? Number(sessionStorage.getItem('tabType')) : 0;
                //从智能陪练短链进来code为101 课程未开放/过期 自动定位到智能陪练
                _this.route.queryParams.subscribe(function (params) {
                    if (params['code'] == 101) {
                        _this.tabIndex = _this.tabList.findIndex(function (item) { return item.type === 2; });
                    }
                });
                _this.changePos(_this.tabIndex);
                if (Number(sessionStorage.getItem('tabIndex')) && Number(sessionStorage.getItem('tabType')) && _this.projectMsg[0].learningPathMetasDetailList.length > 0) {
                    _this.checkTab(_this.tabIndex, _this.tabType);
                }
                if (!_this.isFirstAITraining && _this.isHaveAITraining) {
                    _this.tabIndex = _this.tabList.findIndex(function (item) { return item.type === 2; });
                    _this.apiService.getProjectSortList(Number(_this.projectId), 2).subscribe(function (result) {
                        _this.projectMsg = result;
                        _this.firstAITrainingData = result[0].learningPathMetasDetailList[0];
                        _this.firstAITrainingData['projectLearingToursVo'].openTime = _this.firstAITrainingData['projectLearingToursVo'].preTestOpenAt ? _this.tansFromTimestamp(_this.firstAITrainingData['projectLearingToursVo'].preTestOpenAt, 1) : '';
                    });
                }
            });
        });
    };
    //项目列表接口和项目学习进度接口
    LearningProjectComponent.prototype.getProjectProgress = function (projectId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/projectProgress?needDetails=true&projectIds=' + projectId,
        }).toPromise();
    };
    //获取项目下课程列表或者散客列表
    LearningProjectComponent.prototype.CoursesOrProjectCourses = function (projectId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'sr/v2/coursesOrProjectCourses?projectId=' + projectId,
        }).toPromise();
    };
    //获取项目下课程列表或者散客列表
    LearningProjectComponent.prototype.changPlayBroadcast = function (vid) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': "ddilearner/v2/broadcast?vid=" + vid,
        }).toPromise();
    };
    /**
     * 进入作业
     */
    LearningProjectComponent.prototype.goHomeWork = function (item) {
        if (item.homeworkExpiryAtFlag) {
            this.lockToast();
            this.promptText = "\u8BE5\u4F5C\u4E1A\u5DF2\u8FC7\u671F";
        }
        else if (!item.homeworkOpenAtFlag) {
            this.lockToast();
            this.promptText = '该作业将于' + this.tansFromTimestamp(item.homeworkOpenAt, 2) + '开放。';
        }
        else {
            if (item.homeworkProgress === 100 || item.homeworkCloseAtFlag) {
                // alert('正在施工中...');
                if (item.constituteId !== null && item.constituteId > 0) {
                    this.router.navigate(['learning-camp-response'], { queryParams: { tabNum: 0, constituteId: item.constituteId, projectId: this.projectId, 'homeworkCloseAtFlag': item.homeworkCloseAtFlag ? 1 : 0 } }).then();
                }
                else {
                    this.router.navigate(['home-work-show', item['homeworkDuplicateId']], { queryParams: { 'projectId': this.projectId, 'tabNum': 0, 'homeworkCloseAtFlag': item.homeworkCloseAtFlag ? 1 : 0 } }).then();
                }
            }
            else {
                if (item.constituteId !== null && item.constituteId > 0) {
                    this.router.navigate(['exercise-work', item['constituteId']], { queryParams: { projectId: this.projectId } });
                }
                else {
                    this.router.navigate(['home-work', this.projectId, item['homeworkDuplicateId']]).then();
                }
            }
        }
    };
    // 进到课程学历里面
    LearningProjectComponent.prototype.goLearnPath = function (raw) {
        var _this = this;
        console.log('课程信息', raw);
        if (raw.isUserTicketExpiry) {
            this.lockToast();
            this.promptText = "\u8BE5\u8BFE\u7A0B\u5DF2\u8FC7\u671F";
        }
        else if (raw.projectLearingToursVo.lock) {
            this.lockToast();
            this.promptText = "\u8BE5\u8BFE\u7A0B\u5C06\u4E8E" + (raw.projectLearingToursVo.promptTime ? raw.projectLearingToursVo.promptTime : this.tansFromTimestamp(raw.projectLearingToursVo.preTestOpenAt, 2)) + "\u5F00\u653E\u3002";
        }
        else {
            if (Number(raw.learningPathMetaId) > 5000 && Number(raw.learningPathMetaId) < 6000) {
                this.router.navigate(['app-scorm', raw.learningPathMetaId], { queryParams: { version: raw.abilityVersion, name: raw.name, projectId: this.projectId } });
            }
            else {
                var link = ['learning-path', raw.id ? raw.id : raw.learningPathMetaId];
                if (raw.abilityVersion === '智能陪练') {
                    var exerciseIds_1 = '';
                    this.route.queryParams.subscribe(function (params) {
                        exerciseIds_1 = params.exerciseIds && params.exerciseIds != 'undefined' ? params.exerciseIds : '';
                    });
                    this.getOrCreateLearningPath(raw.learningPathMetaId).then(function () {
                        var token = localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '';
                        var mobProjectUrl = window.location.origin + '/learning-project/' + _this.projectId; //mob项目列表
                        var IntelligentUrl = window.location.origin + '/ai/aicoach/list/' + raw.courseId + '?device=mobile' + '&projectId=' + _this.projectId + '&exerciseIds=' + exerciseIds_1 + '&back_url=' + encodeURIComponent(mobProjectUrl) + '&transtalent_token=' + token;
                        window.location.href = IntelligentUrl;
                    });
                    return;
                }
                if (raw.learningPathMetaId == 0) {
                    this.commonService.setStorage('dnaReturnUrl', location.href);
                    link = ['survey', this.projectMsg[0].tour_id ? this.projectMsg[0].tour_id : this.tour_id, 1, 2];
                }
                this.router.navigate(link);
            }
        }
    };
    // 课程锁住原因提示
    LearningProjectComponent.prototype.lockToast = function () {
        var _this = this;
        this.isShowPrompt = true;
        setTimeout(function () {
            _this.isShowPrompt = false;
        }, 2000);
    };
    // 返回课程列表页面
    LearningProjectComponent.prototype.goToLearningMap = function () {
        this.router.navigate(['learning-map']);
        sessionStorage.removeItem('scrollHeight');
        sessionStorage.removeItem('tabIndex');
        sessionStorage.removeItem('tabType');
    };
    // 打开宣讲视频窗口
    LearningProjectComponent.prototype.openVideo = function () {
        var _this = this;
        // console.log('打开宣讲视频弹窗')
        this.isShowvideoDialog = true;
        setTimeout(function () {
            console.log(window.frames.innerWidth);
            _this.initVideoPlayer(window.frames.innerWidth, window.frames.innerWidth / 16 * 9);
        }, 300);
    };
    // 进入学习
    LearningProjectComponent.prototype.goNext = function (evn) {
        this.player.destroy();
        this.isShowvideoDialog = false;
    };
    // 视频播放设置
    LearningProjectComponent.prototype.initVideoPlayer = function (width, height) {
        var self = this;
        var player = polyvPlayer({
            wrap: '#video',
            'width': width,
            'height': height,
            'vid': this.videoId,
            'forceH5': true
        });
        this.player = player;
        this.player.on('s2j_onPlayStart', function () {
            if (!self.projectMsg[0].isBroadcast) {
                if (self.isClickPlay) {
                    return false;
                }
                self.changPlayBroadcast(self.videoId);
                self.isClickPlay = true;
            }
        });
    };
    //进入训练营
    LearningProjectComponent.prototype.goCampList = function (skuId, campId) {
        localStorage.setItem('skuId', skuId);
        localStorage.setItem('campId', campId);
        this.router.navigate(['learning-camp', skuId, campId]);
    };
    //切换
    LearningProjectComponent.prototype.checkTab = function (index, type) {
        var _this = this;
        this.tabIndex = index;
        this.tabType = type;
        if (this.isStickey) {
            this.judgePos();
        }
        this.changePos(this.tabIndex);
        this.apiService.getProjectSortList(Number(this.projectId), type).subscribe(function (result) {
            //把含有小工具的过滤掉
            result[0].learningPathMetasDetailList = result[0].learningPathMetasDetailList.filter(function (item) { return item.learningPathMetaId !== 999; });
            _this.projectMsg = result;
            //有训练营需要过滤掉dna
            if (_this.projectMsg[0].campMetasList.length > 0) {
                _this.projectMsg[0].learningPathMetasDetailList = _this.projectMsg[0].learningPathMetasDetailList.filter(function (item) { return item.learningPathMetaId !== 0; });
            }
            //重新设置训练营的campOpenTime
            if (_this.projectMsg[0].totalCampMetasNum && _this.projectMsg[0].totalCampMetasNum > 0) {
                _this.projectMsg[0].campMetasList.map(function (item) {
                    item.campOpenTime = item.preTestOpenTime ? _this.tansFromTimestamp(item.preTestOpenTime, 1) : '';
                });
            }
            //设置智能陪练课程开放时间
            _this.projectMsg[0].learningPathMetasDetailList.forEach(function (item) {
                if (item.projectLearingToursVo) {
                    var preTestOpenAt = item.projectLearingToursVo.preTestOpenAt;
                    item.projectLearingToursVo.openTime = preTestOpenAt ? _this.tansFromTimestamp(preTestOpenAt, 1) : '';
                    item.projectLearingToursVo.promptTime = preTestOpenAt ? _this.tansFromTimestamp(preTestOpenAt, 2) : '';
                }
            });
            //切换到每个tab下的数量是否不够屏幕滚动的数量 不够添加
            for (var i = _this.tabIndex == 0 ? _this.projectMsg[0].totalCampMetasNum + _this.projectMsg[0].learningPathMetasDetailList.length : _this.projectMsg[0].learningPathMetasDetailList.length; i < 6; i++) {
                _this.projectMsg[0].learningPathMetasDetailList.push({});
            }
        });
        if (this.isStickey && this.tabIndex == this.tabList.length - 1) {
            document.getElementById('tabBar').scrollTo({
                left: 10,
                behavior: 'smooth'
            });
        }
        sessionStorage.setItem('tabIndex', String(this.tabIndex));
        sessionStorage.setItem('tabType', String(this.tabType));
    };
    LearningProjectComponent.prototype.changePos = function (index) {
        //改变滑条距离
        var tabItem = document.getElementById("tabItem-" + index);
        var firstTabItem = document.getElementById("tabItem-0");
        document.getElementById('line').style.width = tabItem.offsetWidth - 5 + 'px';
        document.getElementById('line').style.transform = this.isStickey ? "translateX(" + (tabItem.offsetLeft - firstTabItem.offsetLeft) + "px)" : index == 0 ? "" : "translateX(" + tabItem.offsetLeft + "px)";
    };
    //去下一步
    LearningProjectComponent.prototype.goNextStep = function () {
        var _this = this;
        this.stepNum++;
        if (this.stepNum == 1) {
            this.guideTipCon = '点击全部，查看你的学习旅程，开始学习吧。';
            this.guideTipBtn = '知道了';
            var dom = document.getElementById('tabBar');
            document.getElementById('guideTip').style.top = dom.offsetTop + 34 + 14 + 'px';
            document.getElementById('guideTip').style.left = 15 + 'px';
            document.getElementById('arrow').style.left = 15 + 'px';
        }
        else {
            document.getElementById('mask').style.display = 'none';
            //做完新手引导
            this.commonService.setOnceIno(this.commonService.getOnceValue(this.projectId, 15)).subscribe(function (res) {
                _this.isFirstAITraining = true;
            });
        }
    };
    // 根据learningPathMetaId创建或者获取LearningPath
    LearningProjectComponent.prototype.getOrCreateLearningPath = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learningpathes/' + learningPathMetaId
        }).toPromise();
    };
    return LearningProjectComponent;
}());
export { LearningProjectComponent };



// WEBPACK FOOTER //
// ./src/app/learning-project/learning-project.component.ts.pre-build-optimizer.js